import { Component } from '@angular/core';

@Component({
  selector: 'dailybackup-reports',
  templateUrl: './dailybackup.view.reports.component.html',
})
export class DailyBackupViewReportsComponent {
  constructor() {}
}
